"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = require("prop-types");
var _ToggleSwitch = require("../../../ToggleSwitch");
var _DropdownMenu = require("./DropdownMenu.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DropdownMenu = function DropdownMenu(_ref) {
  var title = _ref.title,
    enabled = _ref.enabled,
    onToggle = _ref.onToggle,
    onClear = _ref.onClear;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    toggleDropdown = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    confirmingDelete = _useState4[0],
    setConfirmingDelete = _useState4[1];
  var toggle = function toggle() {
    toggleDropdown(function (prevState) {
      return !prevState;
    });
    if (confirmingDelete) {
      setConfirmingDelete(false);
    }
  };
  var handleDelete = function handleDelete() {
    if (!confirmingDelete) {
      setConfirmingDelete(true);
    }
  };
  var handleClear = function handleClear() {
    onClear();
    toggle();
  };
  return _react["default"].createElement(_DropdownMenu.StyledDropdown, {
    isOpen: isOpen,
    toggle: toggle
  }, _react["default"].createElement(_DropdownMenu.StyledDropdownToggle, null, _react["default"].createElement(_DropdownMenu.EllipsisIcon, {
    icon: _freeSolidSvgIcons.faEllipsisH
  })), _react["default"].createElement(_DropdownMenu.StyledDropdownMenu, null, _react["default"].createElement(_DropdownMenu.StyledDropdownItem, {
    toggle: false
  }, _react["default"].createElement(_DropdownMenu.ToggleSwitchWrapper, {
    htmlFor: "toggle-switch"
  }, _react["default"].createElement(_ToggleSwitch.ToggleSwitch, {
    on: enabled,
    onClick: onToggle,
    id: "toggle-switch",
    "data-testid": "toggle-switch",
    className: "toggle"
  }), _react["default"].createElement(_DropdownMenu.StyledDropdownItemLabel, null, "Enable ", title))), _react["default"].createElement(_DropdownMenu.StyledDropdownItem, {
    $color: confirmingDelete && '#DE2F1B',
    onClick: handleDelete,
    toggle: false,
    "data-testid": "delete-button"
  }, !confirmingDelete && _react["default"].createElement(_DropdownMenu.StyleMenuItemIcon, {
    icon: _freeSolidSvgIcons.faTrash
  }), confirmingDelete ? _react["default"].createElement("span", null, "Are you sure?", ' ', _react["default"].createElement(_DropdownMenu.ActionButton, {
    "data-testid": "yes-delete-button",
    onClick: handleClear
  }, "Yes"), ' ', _react["default"].createElement(_DropdownMenu.ActionButton, {
    "data-testid": "no-delete-button",
    onClick: toggle
  }, "No")) : _react["default"].createElement("span", null, "Clear ", title))));
};
DropdownMenu.propTypes = {
  title: _propTypes.string.isRequired,
  enabled: _propTypes.bool.isRequired,
  onToggle: _propTypes.func.isRequired,
  onClear: _propTypes.func.isRequired
};
var _default = exports["default"] = DropdownMenu;